/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Faq_A6Inputs */

const en_cad_faq_a6 = /** @type {(inputs: Cad_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is in early, fast development. Many core drafting commands already work, but some AutoCAD features are missing (for example, SHX fonts are not read yet). Review the project's roadmap and gap list, and keep backups.`)
};

/**
* | output |
* | --- |
* | "It is in early, fast development. Many core drafting commands already work, but some AutoCAD features are missing (for example, SHX fonts are not read yet). ..." |
*
* @param {Cad_Faq_A6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_faq_a6 = /** @type {((inputs?: Cad_Faq_A6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Faq_A6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_faq_a6(inputs)
});
export { cad_faq_a6 as "cad.faq.a6" }